import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import SearchIcon from "@mui/icons-material/Search";
import FilterListIcon from "@mui/icons-material/FilterList";
import { useGlobalContext } from "../../../Context/GlobalContext";
import ClipLoader from "react-spinners/ClipLoader";
import PayrollAdvancePaid from "../../../components/Staff/Modals/PayrollAdvancePaid";
import PayrollAdvanceAction from "../../../components/Staff/Modals/PayrollAdvanceAction";
import Cookies from "js-cookie";
import AddIcon from "@mui/icons-material/Add";
import PayrollFinalizedSidebar from "../../../components/Staff/Modals/PayrollFinalizedSidebar";
import Modal from "react-modal";
import CloseIcon from "@mui/icons-material/Close";
import { saveAs } from "file-saver";
import { usePayrollContext } from "../../../Context/PayrollContext";

const AdvancePayroll = () => {
  let subtitle;
  const {
    isLoading,
    openToast,
    baseUrl,
    setSelectedStaff,
    selectDepartments,
    handleChangeDepartment,
    departments,
    resetState,
  } = useGlobalContext();
  const { fetchPayrollDetails, handleMonthChange, year, month, payrollDetail, loading } = usePayrollContext();
  console.log(fetchPayrollDetails)
  const [isOffCanvasOpen, setIsOffCanvasOpen] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [isOffCanvasOpenAction, setIsOffCanvasOpenAction] = useState(false);
  const [paidPaymentPrice, setPaidPaymentPrice] = useState("");
  const [selectedItem, setSelectedItem] = useState(null);
  const [selectedPayroll, setSelectedPayroll] = useState(null);
  const [payrollFinalized, setPayrollFinalized] = useState(false);
  const [modalIsOpen9, setIsOpen9] = React.useState(false);

  function openModal9() {
    setIsOpen9(true);
  }
  function afterOpenModal9() {
    subtitle.style.color = "#000";
  }

  function closeModal9() {
    setIsOpen9(false);
  }

  const toggleOffCanvasPayrollFinalized = () => {
    setPayrollFinalized(!payrollFinalized);
  };

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  const toggleOffCanvas = () => {
    setIsOffCanvasOpen(!isOffCanvasOpen);
  };
  const toggleOffCanvasAction = () => {
    setIsOffCanvasOpenAction(!isOffCanvasOpenAction);
  };

  const [activeDropdown, setActiveDropdown] = useState(null);

  const handleDrop = (dropdown) => {
    setActiveDropdown((prev) => (prev === dropdown ? null : dropdown));
  };

  const handleClickOutside = (event) => {
    if (!event.target.closest(".dropdown-container")) {
      setActiveDropdown(null);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);



  const exportToCSV = () => {
    // Prepare the CSV headers
    const headers = [
      "Index",
      "Name",
      "Job Title",
      "Ctc",
      "Payroll Finalized",
      "Total Incentives",
    ];

    // Map over the data to create CSV rows
    const rows = payrollDetail.map((staff, index) => [
      index + 1,
      staff?.name || "N/A",
      staff?.staffDetails?.job_title || "N/A",
      staff?.staffDetails?.SalaryDetails[0]?.ctc_amount || "N/A",
      staff?.staffDetails?.SalaryDetails?.[0]?.PaymentHistory?.filter(
        (item) => item?.type === "ADVANCE"
      ).reduce((acc, curr) => acc + (curr?.amount || 0), 0) || 0,
      staff?.staffDetails?.SalaryDetails[0]?.payroll_finalized ? "Yes" : "No",
      staff?.staffDetails?.SalaryDetails[0]?.Incentive.reduce(
        (t, c) => t + c.amount,
        0
      ) ?? "0.00",
    ]);

    // Combine headers and rows for CSV format
    const csvData = [headers, ...rows].map((row) => row.join(",")).join("\n");

    // Create a Blob and download the file
    const blob = new Blob([csvData], { type: "text/csv;charset=utf-8;" });
    saveAs(blob, "AdvancePayroll.csv");
  };
  return (
    <>
      <PayrollAdvancePaid
        offCanvas={toggleOffCanvas}
        isOffCanvasOpen={isOffCanvasOpen}
        setIsOffCanvasOpen={toggleOffCanvas}
        paidPayment={paidPaymentPrice}
        setPaidPayment={setPaidPaymentPrice}
        item={selectedItem}
      />
      <PayrollAdvanceAction
        isOffCanvasOpenAction={isOffCanvasOpenAction}
        setIsOffCanvasOpenAction={toggleOffCanvasAction}
        toggleOffCanvasAction={toggleOffCanvasAction}
        item={selectedItem}
        payrollFun={fetchPayrollDetails}
      />
      <PayrollFinalizedSidebar
        offCanvas={toggleOffCanvasPayrollFinalized}
        isOffCanvasOpen={payrollFinalized}
        setIsOffCanvasOpen={toggleOffCanvasPayrollFinalized}
        data={selectedPayroll}
        fetchPayrollDetails={fetchPayrollDetails}
      />

      <div className="mt-[20px]">
        <div className="flex xl:flex-row flex-col md:flex-col lg:flex-col justify-between items-end gap-[15px] lg:gap-[0px]">
          <div className="flex lg:flex lg:flex-row flex-col justify-between lg:justify-start xl:justify-start gap-[10px] lg:gap-[20px] w-full">
            <div className="xl:w-[240px]">
              <label htmlFor="" className="font-medium text-[14px]">
                Payroll Month
              </label>
              <br />
              <input
                type="month"
                className="p-[8px] border rounded-md w-[100%] lg:w-[240px] font-normal text-[14px] focus-visible:outline-none"
                onChange={handleMonthChange}
                value={`${year}-${month}`}
              />
            </div>
            <div className="xl:w-[240px]">
              <label htmlFor="" className="font-medium text-[14px]">
                Company Branches
              </label>
              <br />
              <select className="p-[8px] border rounded-md w-[100%] lg:w-[240px] font-normal text-[14px] focus-visible:outline-none">
                <option>All Branches</option>
                <option>Demo Main Branchs</option>
              </select>
            </div>

            <div className="xl:w-[240px]">
              <label htmlFor="" className="font-medium text-[14px]">
                Departments
              </label>
              <br />
              <select
                value={selectDepartments}
                onChange={(e) => handleChangeDepartment(e.target.value)}
                className="p-[8px] border rounded-md w-[100%] lg:w-[240px] font-normal text-[14px] focus-visible:outline-none"
              >
                <option>Select a Department</option>
                {departments.map((departmentName, index) => (
                  <option key={index} value={departmentName?.department_name}>
                    {departmentName?.department_name}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="w-full md:w-auto">
            <button
              onClick={resetState}
              className="justify-center w-full md:w-auto second-btn"
            >
              Reset
            </button>
          </div>
        </div>
        <div className="mt-[20px]">
          <div className="flex lg:flex-row xl:flex-row flex-col justify-between items-start lg:items-center xl:items-center gap-[10px] mb-[20px]">
            <div className="relative summary-border rounded-[10px] w-full lg:w-[240px] xl:w-[240px]">
              <input
                type="text"
                placeholder="Search"
                className="px-[10px] py-[9px] pr-[26px] pl-[10px] rounded-[10px] text-[13px] client-add focus-visible:outline-none"
              />
              <SearchIcon className="top-[12px] right-[6px] absolute text-gray-500 newadd2" />
            </div>

            <button
              onClick={openModal9}
              className="justify-center w-full md:w-auto second-btn"
            >
              Import Advance
            </button>
          </div>
        </div>

        <div className="border-[#dcdbdb] bg-white shadow-cs mt-[20px] border rounded-lg w-full h-[100%] overflow-x-auto">
          <table className="border-[#dcdbdb] border-collapse border rounded-lg w-full overflow-hidden table-auto">
            <thead
              className="border-gray-300 shadow-md border"
              onClick={toggleAccordion}
            >
              <tr>
                <th className="p-[10px] border-r font-medium text-center text-xs whitespace-nowrap">
                  <div className="flex justify-center items-center">
                    Name
                    <div className="relative dropdown-container">
                      <button onClick={() => handleDrop("name")}>
                        <FilterListIcon className="filter-icon" />
                      </button>

                      {activeDropdown === "name" && (
                        <div
                          className="left-[0px] z-10 absolute bg-white ring-opacity-5 shadow-lg mt-2 rounded-md divide-y divide-gray-100 ring-1 ring-black w-56 text-left origin-top-right focus:outline-none"
                          role="menu"
                          aria-orientation="vertical"
                          aria-labelledby="menu-button"
                          tabIndex="-1"
                        >
                          <div className="py-1" role="none">
                            <Link
                              to="/add-one-staff"
                              className="block px-4 py-2 text-gray-700 text-sm"
                              role="menuitem"
                              tabIndex="-1"
                              id="menu-item-0"
                            >
                              Sort A to Z
                            </Link>
                            <Link
                              to="#"
                              className="block px-4 py-2 text-gray-700 text-sm"
                              role="menuitem"
                              tabIndex="-1"
                              id="menu-item-1"
                            >
                              Sort Z to A
                            </Link>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </th>
                <th className="p-[10px] border-r font-medium text-center text-xs whitespace-nowrap">
                  <div className="flex justify-center items-center">
                    Job Title
                    <div className="relative dropdown-container">
                      <button onClick={() => handleDrop("job")}>
                        <FilterListIcon className="filter-icon" />
                      </button>

                      {activeDropdown === "job" && (
                        <div
                          className="left-[0px] z-10 absolute bg-white ring-opacity-5 shadow-lg mt-2 rounded-md divide-y divide-gray-100 ring-1 ring-black w-56 text-left origin-top-right focus:outline-none"
                          role="menu"
                          aria-orientation="vertical"
                          aria-labelledby="menu-button"
                          tabIndex="-1"
                        >
                          <div className="py-1" role="none">
                            <Link
                              to="/add-one-staff"
                              className="block px-4 py-2 text-gray-700 text-sm"
                              role="menuitem"
                              tabIndex="-1"
                              id="menu-item-0"
                            >
                              Sort A to Z
                            </Link>
                            <Link
                              to="#"
                              className="block px-4 py-2 text-gray-700 text-sm"
                              role="menuitem"
                              tabIndex="-1"
                              id="menu-item-1"
                            >
                              Sort Z to A
                            </Link>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </th>
                <th className="p-[10px] border-r font-medium text-center text-xs whitespace-nowrap">
                  <div className="flex justify-center items-center">
                    CTC
                    <div className="relative dropdown-container">
                      <button onClick={() => handleDrop("ctc")}>
                        <FilterListIcon className="filter-icon" />
                      </button>

                      {activeDropdown === "ctc" && (
                        <div
                          className="left-[0px] z-10 absolute bg-white ring-opacity-5 shadow-lg mt-2 rounded-md divide-y divide-gray-100 ring-1 ring-black w-56 text-left origin-top-right focus:outline-none"
                          role="menu"
                          aria-orientation="vertical"
                          aria-labelledby="menu-button"
                          tabIndex="-1"
                        >
                          <div className="py-1" role="none">
                            <Link
                              to="/add-one-staff"
                              className="block px-4 py-2 text-gray-700 text-sm"
                              role="menuitem"
                              tabIndex="-1"
                              id="menu-item-0"
                            >
                              Sort A to Z
                            </Link>
                            <Link
                              to="#"
                              className="block px-4 py-2 text-gray-700 text-sm"
                              role="menuitem"
                              tabIndex="-1"
                              id="menu-item-1"
                            >
                              Sort Z to A
                            </Link>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </th>
                <th className="p-[10px] border-r font-medium text-center text-xs whitespace-nowrap">
                  <div className="flex justify-center items-center">
                    Advance Paid
                    <div className="relative dropdown-container">
                      <button onClick={() => handleDrop("payroll")}>
                        <FilterListIcon className="filter-icon" />
                      </button>

                      {activeDropdown === "payroll" && (
                        <div
                          className="left-[0px] z-10 absolute bg-white ring-opacity-5 shadow-lg mt-2 rounded-md divide-y divide-gray-100 ring-1 ring-black w-56 text-left origin-top-right focus:outline-none"
                          role="menu"
                          aria-orientation="vertical"
                          aria-labelledby="menu-button"
                          tabIndex="-1"
                        >
                          <div className="py-1" role="none">
                            <Link
                              to="/add-one-staff"
                              className="block px-4 py-2 text-gray-700 text-sm"
                              role="menuitem"
                              tabIndex="-1"
                              id="menu-item-0"
                            >
                              Sort A to Z
                            </Link>
                            <Link
                              to="#"
                              className="block px-4 py-2 text-gray-700 text-sm"
                              role="menuitem"
                              tabIndex="-1"
                              id="menu-item-1"
                            >
                              Sort Z to A
                            </Link>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </th>
                <th className="p-[10px] border-r font-medium text-center text-xs whitespace-nowrap">
                  <div className="flex justify-center items-center">
                    Payroll Finalized
                  </div>
                </th>

                <th className="p-[10px] border-r font-medium text-center text-xs whitespace-nowrap">
                  <div className="flex justify-center items-center">
                    Bank/UPI Verfied
                    <div className="relative dropdown-container">
                      <button onClick={() => handleDrop("bank")}>
                        <FilterListIcon className="filter-icon" />
                      </button>

                      {activeDropdown === "bank" && (
                        <div
                          className="left-[0px] z-10 absolute bg-white ring-opacity-5 shadow-lg mt-2 rounded-md divide-y divide-gray-100 ring-1 ring-black w-56 text-left origin-top-right focus:outline-none"
                          role="menu"
                          aria-orientation="vertical"
                          aria-labelledby="menu-button"
                          tabIndex="-1"
                        >
                          <div className="py-1" role="none">
                            <Link
                              to="/add-one-staff"
                              className="block px-4 py-2 text-gray-700 text-sm"
                              role="menuitem"
                              tabIndex="-1"
                              id="menu-item-0"
                            >
                              Sort A to Z
                            </Link>
                            <Link
                              to="#"
                              className="block px-4 py-2 text-gray-700 text-sm"
                              role="menuitem"
                              tabIndex="-1"
                              id="menu-item-1"
                            >
                              Sort Z to A
                            </Link>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </th>

                <th className="p-[10px] border-r font-medium text-center text-xs whitespace-nowrap">
                  <div className="flex justify-center items-center">Action</div>
                </th>
              </tr>
            </thead>

            <tbody className="border-b w-full">
              {loading && (
                <tr className="h-[100px]">
                  <td
                    colSpan="9"
                    className="border-[#dbdbdb] py-4 font-semibold text-center text-gray-600 text-xl whitespace-nowrap"
                  >
                    <ClipLoader color="#24007a" size={50} />
                  </td>
                </tr>
              )}
              {!loading &&
                payrollDetail &&
                payrollDetail?.map((staff) => {
                  let formattedPending = 0;
                  let formattedTotal = 0;
                  return (
                    <tr key={staff?.id} className="border-1 border-b">
                      <td className="border-[#dbdbdb] p-[10px] border-r text-center text-xs whitespace-nowrap">
                        <Link
                          onClick={() => setSelectedStaff(staff)}
                          to={`/personal-detail/${staff?.id}`}
                          className="font-medium text-[#8A25B0] cursor-pointer"
                        >
                          {staff?.name || "N/A"}
                        </Link>
                      </td>
                      <td className="border-[#dbdbdb] p-[10px] border-r text-center text-xs whitespace-nowrap">
                        {staff?.staffDetails?.job_title || "N/A"}
                      </td>

                      {staff?.staffDetails?.SalaryDetails[0]?.ctc_amount ? (
                        <>
                          <td className="border-[#dbdbdb] p-[10px] border-r text-center text-xs whitespace-nowrap">
                            {staff?.staffDetails?.SalaryDetails[0]?.ctc_amount}
                          </td>
                          <td className="border-[#dbdbdb] p-[10px] border-r text-[#24007a] text-center text-xs whitespace-nowrap">
                            <button
                              onClick={() => {
                                setIsOffCanvasOpen(true);
                                setPaidPaymentPrice(staff);
                                setSelectedItem(staff);
                              }}
                            >
                              {/* {staff?.staffDetails?.SalaryDetails[0]?.PaymentHistory.filter((item) => item?.type === ADVANCE).reduce((acc, curr) => acc + curr?.amount, 0) || 0} */}
                              ₹{" "}
                              {staff?.staffDetails?.SalaryDetails?.[0]?.PaymentHistory?.filter(
                                (item) => item?.type === "ADVANCE"
                              ).reduce(
                                (acc, curr) => acc + (curr?.amount || 0),
                                0
                              ) || 0}
                            </button>
                          </td>
                          <td className="border-[#dbdbdb] p-[10px] border-r text-[#24007a] text-center text-xs whitespace-nowrap">
                            <button
                              onClick={() => {
                                setSelectedPayroll({
                                  ...staff,
                                  pending: formattedPending,
                                  total: formattedTotal,
                                });
                                setPayrollFinalized(true);
                              }}
                            >
                              {staff?.staffDetails?.SalaryDetails[0]
                                ?.payroll_finalized
                                ? "Yes"
                                : "No"}
                            </button>
                          </td>
                          <td className="border-[#dbdbdb] p-[10px] border-r text-center text-xs whitespace-nowrap">
                            {" "}
                            N/A
                          </td>
                          <td className="border-[#dbdbdb] p-[10px] border-r text-[#8A25B0] text-center text-xs whitespace-nowrap">
                            <button
                              onClick={() => {
                                setIsOffCanvasOpenAction(true);
                                setSelectedItem(staff);
                              }}
                            >
                              Pay Advance
                            </button>
                          </td>
                        </>
                      ) : (
                        // Show a single column if ctc_amount is not available
                        <td
                          className="border-[#dbdbdb] p-[10px] text-center text-xs whitespace-nowrap"
                          colSpan="5" // Span across all columns
                        >
                          Please{" "}
                          <Link
                            to={`/salary-details-edit/${staff?.id}`}
                            onClick={() => {
                              setSelectedStaff(staff);
                            }}
                            className="font-medium text-[#24007a]"
                          >
                            add ctc
                          </Link>{" "}
                          to continue
                        </td>
                      )}
                    </tr>
                  );
                })}


              {
                !loading && payrollDetail?.length == 0 && (
                  <tr className="h-[100px]">
                    <td
                      colSpan="9"
                      className="border-[#dbdbdb] py-4 text-[14px] text-black text-center whitespace-nowrap"
                    >
                      No Data Found
                    </td>
                  </tr>
                )
              }
            </tbody>



            {/* <div className='mb-0 w-full'>
                        <h2 className='p-[10px] pl-0 whitespace-nowrap'>Grand Total</h2>
                    </div> */}
          </table>
        </div>
        <div className="w-full">
          <h2 className="p-[10px] pl-2 whitespace-nowrap">Grand Total</h2>
        </div>

        <Modal
          isOpen={modalIsOpen9}
          onAfterOpen={afterOpenModal9}
          onRequestClose={closeModal9}
          // style={customStyles}
          contentLabel="Example Modal"
          className="top-[50%] bottom-auto left-[50%] absolute bg-[#fff] shadow-md p-0 rounded-[10px] w-[96%] xl:w-[40%] translate-x-[-50%] translate-y-[-50%]"
        >
          <h2
            ref={(_subtitle) => (subtitle = _subtitle)}
            className="bg-[#F0F6FE] p-3 border-b rounded-b-none rounded-r-lg rounded-t-lg font-medium text-[14px] text-center"
          >
            Import Advance for all Staff
          </h2>
          <button
            onClick={closeModal9}
            className="top-[3px] right-[5px] absolute bg-[#511992] rounded-full font-semibold"
          >
            <CloseIcon className="text-white" />
          </button>
          <div className="pb-2">
            <div className="flex justify-between items-center p-[10px] pl-[20px] border border-t-0 border-r-0 border-b border-l-0 font-medium text-[13px] xl:text-[14px]">
              <div className="flex items-center gap-[0px]">
                <h4 className="m-0 font-medium">
                  Step 1. Download Salarybox Incentive Template.
                </h4>
              </div>
              <div className="flex items-center">
                <Link
                  to="#"
                  className="p-1 rounded-md text-[13px] whitespace-nowrap outline-1 outline-dashed outline-offset-1"
                  onClick={exportToCSV}
                >
                  Download Template
                </Link>
              </div>
            </div>

            <div className="flex justify-between items-center p-[10px] pl-[20px] border border-t-0 border-r-0 border-b border-l-0 font-medium text-[13px] xl:text-[14px]">
              <div className="flex items-center gap-[0px]">
                <h4 className="m-0 font-medium">Step 3. Upload Incentives</h4>
              </div>
              <div className="flex items-center">
                <button className="p-1 rounded-md text-[13px] outline-1 outline-dashed outline-offset-1">
                  Import Incentives
                </button>
                {/* <input type='file' placeholder='ddjfksj'/> */}
              </div>
            </div>
          </div>
        </Modal>
      </div>
    </>
  );
};

export default AdvancePayroll;
